export default __webpack_public_path__ + "static/media/miguel-lopes-43.229c13d5.jpg";